<template>
	<div class="question-detail">
		<div class="question-title">{{ questionDetail.question }}</div>
		<div class="question-info">
			<p class="question-type">{{ getSourceBizText(questionDetail) }}</p>
			<p class="question-time">{{ questionDetail.questionTime }}</p>
		</div>
		<div class="question-content">{{ questionDetail.answer }}</div>
	</div>
</template>

<script setup>
import { ref, onMounted } from 'vue';
import { useRoute } from '@/utils/vue-api';
import { useQuestionDetailData } from '@rebuild/materials/shared/question/composables/useQuestionDetailData';
import { useQuestionDisplayUtils } from '@rebuild/materials/shared/question/composables/useQuestionDisplayUtils';

const route = useRoute();
const questionDetail = ref({});

const { fetchQuestionDetail } = useQuestionDetailData();
const { getSourceBizText } = useQuestionDisplayUtils();

const getQuestionDetail = async () => {
	const detail = await fetchQuestionDetail(route.query);
	if (!detail) return;
	questionDetail.value = detail;
};

onMounted(() => {
	getQuestionDetail();
});
</script>

<style lang="less" scoped>
.question-detail {
	overflow-y: auto;
	color: #12121a;

	padding: 0 16px;
	height: 100%;
	.question-title {
		padding-top: 12px;
		font-size: 20px;
		font-weight: 600;
		line-height: 28px; /* 140% */
	}
	.question-content {
		padding: 16px 0;
		font-size: 16px;
		font-weight: 400;
		line-height: 30px; /* 187.5% */
	}
	.question-info {
		margin-top: 8px;
		display: flex;
		justify-content: space-between;
		.question-type {
			color: #4e5969;
			background: #f2f3f5;

			font-size: 10px;
			font-weight: 400;
			padding: 0 4px;
			line-height: 18px;
		}
		.question-time {
			color: #86909c;

			font-size: 14px;
			font-weight: 400;
		}
	}
	&::-webkit-scrollbar {
		display: none;
	}
}
</style>
